import React from 'react'
import "./index.css"
import { Container, Nav, NavDropdown, Navbar } from 'react-bootstrap'
import { APP_NAME } from '../constants'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { useDispatch, useSelector } from 'react-redux'
import { darkModeAction, lightModeAction } from '../../redux/actions/darkModeActions'
import Cookies from 'js-cookie'

function Header(props) {
    const onLogout = () => {
        Cookies.remove("jwt_token")
        const { history } = props;
        history.replace("/")
    }

    const darkModeState = useSelector(state => state.darkModeReducer.isDarkMode);
    console.log("🚀 ~ Header ~ darkModeState:", darkModeState)
    
    const dispatch = useDispatch();


    return (
        <div className='header-container'>
            <Navbar fixed='top' bg={darkModeState ? "dark" : "light"} data-bs-theme={darkModeState ? "dark" : "light"} collapseOnSelect expand="md" className="bg-body-tertiary">
                <Container>
                    <Navbar.Brand as={Link} to="/" className='app-header'>
                        <img src="/images/kitchen-logo.png" />
                        <span className='ms-3'>{APP_NAME}</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className='me-auto'></Nav>
                        <Nav>
                            <Nav.Link as={Link} to="/">
                                {/* <Link to="/"> */}
                                Home
                                {/* </Link> */}
                            </Nav.Link>
                            <Nav.Link as={Link} to="/cart" eventKey={2}>
                                {/* <Link to="/cart"> */}
                                Cart
                                {/* </Link> */}
                            </Nav.Link>
                            <Nav.Link href="">
                                {darkModeState ?
                                    <i class="fa-solid fa-moon" title="Dark Mode" onClick={() => { console.log("first");dispatch(lightModeAction()) }}></i> :
                                    <i class="fa-regular fa-sun" title="Light Mode" onClick={() => { console.log("first1"); dispatch(darkModeAction()) }}></i>}
                            </Nav.Link>
                            <Nav.Link eventKey={2} href="">
                                <button className='btn btn-warning logout-button' onClick={onLogout}>Logout</button>

                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

export default withRouter(Header)